import create from "zustand";
import { followProfile, getMyDraft, getMyProfile, updateDraft } from "./apis";
import { showToast } from "./hot-toast";

export const useStore = create((set, get) => ({
    profile: undefined,
    draft: {
        subject: "",
        markdown: "",
        tags: [],
        giphyLink: "",
    },
    fetchProfile: async (wallet) => {
        const response = await getMyProfile(wallet);
        set({ profile: response });
    },

    setProfile: (_profile) =>
        set((state) => ({
            ...state,
            profile: _profile,
        })),

    followOthersProfile: async (username) => {
        if (!get().profile?.wallet) return;
        const result = await followProfile(username, get().profile?.wallet);
        if (result.statusCode === 400) {
            showToast("error", result.message);
            return;
        }
        if (result) {
            showToast("SUCCESS", `Successfully followed ${username}!`);
            set((state) => ({
                ...state,
                profile: result,
            }));
            return;
        }
    },

    fetchDraft: async (wallet) => {
        const response = await getMyDraft(wallet);
        if (response) set({ draft: response });
    },
    updateDraft: async () => {
        if (!get().profile?.wallet) return;
        const draft = get().draft;
        // console.log(draft);
        if (draft?.markdown.trim() === "")
            //|| draft?.subject.trim() === ""
            return;
        const _draft = await updateDraft({
            ...draft,
            wallet: get().profile?.wallet,
        });
        set((state) => ({
            ...state,
            draft: _draft,
        }));
    },
    setDraft: (_draft) =>
        set((state) => ({
            ...state,
            draft: _draft,
        })),
    resetDraft: (_draft) =>
        set((state) => ({
            ...state,
            draft: {
                subject: "",
                markdown: "",
                tags: [],
                giphyLink: "",
            },
        })),
    setSubject: (_subject) =>
        set((state) => ({
            ...state,
            draft: { ...state.draft, subject: _subject },
        })),
    setMarkdown: (_markdown) =>
        set((state) => ({
            ...state,
            draft: { ...state.draft, markdown: _markdown },
        })),
    setGiphyLink: (_giphyLink) =>
        set((state) => ({
            ...state,
            draft: { ...state.draft, giphyLink: _giphyLink },
        })),
    setTags: (_tags) =>
        set((state) => ({
            ...state,
            draft: { ...state.draft, tags: _tags },
        })),
}));
